// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
    width: 40%; /* Adjust the width as needed */
    margin: 100px auto; /* Center horizontally and add top margin */
    padding: 20px; /* Add some padding for the content */
    background-color: rgba(255, 255, 255,0.95); /* Semi-transparent white background */
    border-radius: 20px; /* Add rounded corners for a 3D effect */
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); /* Add shadow for depth */
    position: relative; /* Position relative to add background image */
  }
  
  @media only screen and (max-width: 600px) {
    .form-container {
      width: 90%; /* Adjust width for smaller screens */
      margin: 50px auto; /* Adjust margin for mobile */
    }
  }
  .form-container h2 {
    text-align: center;
    color: #0e2431;
    margin-bottom: 20px;
  }
  .form-container h2 {
    text-align: center;
    color: #0e2431;
    margin-bottom: 20px;
  }
  
  .form-container form {
    display: flex;
    flex-direction: column;
  }
  
  .form-container label {
    margin-bottom: 10px;
    font-size: 1rem;
    color: #0e2431;
  }
  
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="date"] {
    width: 100%;
    padding: 12px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
  }
  
  input[type="text"]:focus,
  input[type="email"]:focus,
  input[type="password"]:focus,
  input[type="date"]:focus  {
    outline: none;
    border-color: #0e2431;
    box-shadow: 0 0 3px rgba(14, 36, 49, 0.5);
  }
  
  .password-container {
    position: relative;
  }
  
  .password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #0e2431;
  }
  
  
  .login-button {
    background-color: #418ff3;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 10px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .login-button:hover {
    background-color: #3778cc;
  }
  
  .divider {
    border: none;
    height: 1px;
    background-color: #ccc;
    margin: 20px 0;
  }
  
  /* New styles for Create an Account button */
  .create-account-button {
    background-color: #0fb175; 
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 12px; /* Decrease padding */
    font-size: 1rem; /* Decrease font size */
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 50%; /* Decrease width */
    margin: 10px auto 0; /* Center horizontally and add top margin */
    display: block; /* Block level element for centering */
  }
  
  .create-account-button:hover {
    background-color: #088a5a;
  }
  
  
  /* New styles for the account prompt text */
  .account-prompt {
    text-align: center; /* Center text */
    color: #0e2431;
    margin-top: 20px; /* Add some spacing above the button */
    font-size: 1rem;
  }
  .form-container .error-message {
    background-color: #f8d7da;
    color: red;
    margin-bottom: 10px;
    text-align: center;
  }
  .form-container .success-message {
    background-color: #d4edda;
    color: #155724;
  }
  /* Tooltip styling */
  .asterisk-tooltip {
    position: relative;
    cursor: help;
    color: red; /* Asterisk color */
  }
  
  .asterisk-tooltip::after {
    content: attr(data-tooltip);
    position: absolute;
    left: 0;
    bottom: 120%; /* Adjust to place the tooltip above the asterisk */
    background-color: black;
    color: white;
    padding: 5px;
    border-radius: 3px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none; /* Makes the tooltip ignore mouse events */
    font-size: 12px;
  }
  
  .asterisk-tooltip:hover::after {
    opacity: 1;
  }`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;IACI,UAAU,EAAE,+BAA+B;IAC3C,kBAAkB,EAAE,2CAA2C;IAC/D,aAAa,EAAE,qCAAqC;IACpD,0CAA0C,EAAE,sCAAsC;IAClF,mBAAmB,EAAE,wCAAwC;IAC7D,uCAAuC,EAAE,yBAAyB;IAClE,kBAAkB,EAAE,8CAA8C;EACpE;;EAEA;IACE;MACE,UAAU,EAAE,qCAAqC;MACjD,iBAAiB,EAAE,6BAA6B;IAClD;EACF;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;;;;IAIE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;;;IAIE,aAAa;IACb,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;;EAGA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,cAAc;EAChB;;EAEA,4CAA4C;EAC5C;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa,EAAE,qBAAqB;IACpC,eAAe,EAAE,uBAAuB;IACxC,eAAe;IACf,sCAAsC;IACtC,UAAU,EAAE,mBAAmB;IAC/B,mBAAmB,EAAE,2CAA2C;IAChE,cAAc,EAAE,sCAAsC;EACxD;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA,2CAA2C;EAC3C;IACE,kBAAkB,EAAE,gBAAgB;IACpC,cAAc;IACd,gBAAgB,EAAE,sCAAsC;IACxD,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAE,mBAAmB;EACjC;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,OAAO;IACP,YAAY,EAAE,mDAAmD;IACjE,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IACxB,oBAAoB,EAAE,0CAA0C;IAChE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ","sourcesContent":[".form-container {\n    width: 40%; /* Adjust the width as needed */\n    margin: 100px auto; /* Center horizontally and add top margin */\n    padding: 20px; /* Add some padding for the content */\n    background-color: rgba(255, 255, 255,0.95); /* Semi-transparent white background */\n    border-radius: 20px; /* Add rounded corners for a 3D effect */\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); /* Add shadow for depth */\n    position: relative; /* Position relative to add background image */\n  }\n  \n  @media only screen and (max-width: 600px) {\n    .form-container {\n      width: 90%; /* Adjust width for smaller screens */\n      margin: 50px auto; /* Adjust margin for mobile */\n    }\n  }\n  .form-container h2 {\n    text-align: center;\n    color: #0e2431;\n    margin-bottom: 20px;\n  }\n  .form-container h2 {\n    text-align: center;\n    color: #0e2431;\n    margin-bottom: 20px;\n  }\n  \n  .form-container form {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .form-container label {\n    margin-bottom: 10px;\n    font-size: 1rem;\n    color: #0e2431;\n  }\n  \n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"date\"] {\n    width: 100%;\n    padding: 12px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem;\n  }\n  \n  input[type=\"text\"]:focus,\n  input[type=\"email\"]:focus,\n  input[type=\"password\"]:focus,\n  input[type=\"date\"]:focus  {\n    outline: none;\n    border-color: #0e2431;\n    box-shadow: 0 0 3px rgba(14, 36, 49, 0.5);\n  }\n  \n  .password-container {\n    position: relative;\n  }\n  \n  .password-toggle {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #0e2431;\n  }\n  \n  \n  .login-button {\n    background-color: #418ff3;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    padding: 10px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .login-button:hover {\n    background-color: #3778cc;\n  }\n  \n  .divider {\n    border: none;\n    height: 1px;\n    background-color: #ccc;\n    margin: 20px 0;\n  }\n  \n  /* New styles for Create an Account button */\n  .create-account-button {\n    background-color: #0fb175; \n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    padding: 12px; /* Decrease padding */\n    font-size: 1rem; /* Decrease font size */\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    width: 50%; /* Decrease width */\n    margin: 10px auto 0; /* Center horizontally and add top margin */\n    display: block; /* Block level element for centering */\n  }\n  \n  .create-account-button:hover {\n    background-color: #088a5a;\n  }\n  \n  \n  /* New styles for the account prompt text */\n  .account-prompt {\n    text-align: center; /* Center text */\n    color: #0e2431;\n    margin-top: 20px; /* Add some spacing above the button */\n    font-size: 1rem;\n  }\n  .form-container .error-message {\n    background-color: #f8d7da;\n    color: red;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n  .form-container .success-message {\n    background-color: #d4edda;\n    color: #155724;\n  }\n  /* Tooltip styling */\n  .asterisk-tooltip {\n    position: relative;\n    cursor: help;\n    color: red; /* Asterisk color */\n  }\n  \n  .asterisk-tooltip::after {\n    content: attr(data-tooltip);\n    position: absolute;\n    left: 0;\n    bottom: 120%; /* Adjust to place the tooltip above the asterisk */\n    background-color: black;\n    color: white;\n    padding: 5px;\n    border-radius: 3px;\n    white-space: nowrap;\n    opacity: 0;\n    transition: opacity 0.2s;\n    pointer-events: none; /* Makes the tooltip ignore mouse events */\n    font-size: 12px;\n  }\n  \n  .asterisk-tooltip:hover::after {\n    opacity: 1;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
